import auto from "#/assets/images/home/auto.png";
import aliro from "#/assets/images/logos/aliro.png";
import yelum from "#/assets/images/logos/yelum.png";

export const LOGO_AUTO = auto;
export const YELUM_LOGO = yelum;
export const ALIRO_LOGO = aliro;
